import React from 'react'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

import styles from './styles'

const Leader = withStyles(styles)(props => {
  const { topper, classes } = props
  return (
    <div className={classes.page}>
      <div className={classes.contents}>
        <div className={classes.lead}>
          <Grid container spacing={40}>
            <Grid item xs={12}>
              <div
                dangerouslySetInnerHTML={{
                  __html: topper.lead && topper.lead.html,
                }}
                className={classnames(classes.richText, classes.leadText)}
              />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(Leader)



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/leader.js